import React from 'react';
import { MenuListItem } from './styles';

export default ({ damList }) => (
  <MenuListItem className="dropdown">
    <a
      className="dropdown-toggle"
      data-toggle="dropdown"
      href="#"
      role="button"
      aria-haspopup="true"
      aria-expanded="false"
    >
      รายชื่ออ่างเก็บน้ำในระบบ <span className="caret" />
    </a>
    <ul className="dropdown-menu">
      {damList.map(({ title, link }, index) => (
        <li key={title}>
          <a href={link} target="_blank">
            {title}
          </a>
        </li>
      ))}
    </ul>
  </MenuListItem>
);



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuLink/MenuDamList.js